export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "imgResizer": {
    "title": "Image Resizer",
    "subtitle": "Resize images for social media, presentations, and web. ",
    "privacy": "100% client-side",
    "noUpload": "no upload needed",
    "uploadTitle": "Upload Images",
    "uploadDesc": "Drag & drop or click to select. Supports JPEG, PNG, WebP.",
    "addFiles": "Add Images",
    "files": "files",
    "preset": "Preset Size",
    "width": "Width",
    "height": "Height",
    "mode": "Resize Mode",
    "modeCover": "Cover",
    "modeContain": "Contain",
    "modeStretch": "Stretch",
    "modeFill": "Fill",
    "bgColor": "Background",
    "processing": "Processing...",
    "resize": "Resize All",
    "invalidFile": "Please select image files",
    "presetInstaPost": "Instagram Post",
    "presetInstaStory": "Instagram Story",
    "presetTwitterHeader": "Twitter/X Header",
    "presetTwitterPost": "Twitter/X Post",
    "presetFacebookCover": "Facebook Cover",
    "presetFacebookPost": "Facebook Post",
    "presetYouTubeThumb": "YouTube Thumbnail",
    "presetLinkedInBanner": "LinkedIn Banner",
    "presetA4Portrait": "A4 Portrait",
    "presetA4Landscape": "A4 Landscape",
    "presetHD": "HD 1080p",
    "presetCustom": "Custom"
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 All image resizing happens locally in your browser. Your images are never uploaded to any server."
    },
    "guide": {
      "title": "How to Use Image Resizer",
      "description": "Resize images for social media, presentations, and web with precise dimension control.",
      "steps": [
        {
          "title": "Upload your image",
          "description": "Drag and drop or click to select an image file. The tool supports JPG, PNG, WebP, and GIF formats."
        },
        {
          "title": "Set dimensions or preset",
          "description": "Enter exact width and height in pixels, or choose from popular presets: Instagram, Twitter, Facebook, LinkedIn, or HD 1080p."
        },
        {
          "title": "Download resized image",
          "description": "Preview the resized image and click download to save it. Aspect ratio can be locked or adjusted freely."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "Precise pixel-level dimension control",
        "Popular social media presets built-in",
        "Maintain or override aspect ratio",
        "Real-time preview before download",
        "Support for JPG, PNG, WebP, and GIF",
        "100% client-side processing — zero data upload"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Are my images sent to a server?",
          "answer": "No. All resizing happens locally in your browser using HTML5 Canvas. Your images are never transmitted or stored externally."
        },
        {
          "question": "Will resizing reduce image quality?",
          "answer": "Downscaling generally preserves good quality. Upscaling may introduce some pixelation depending on the algorithm. For best results, start with the highest resolution source image available."
        },
        {
          "question": "Can I resize multiple images at once?",
          "answer": "Currently the tool processes one image at a time for precise control. For batch resizing, consider using our Image Watermarker tool which supports batch processing."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Image Converter",
          "url": "/image/image-converter",
          "description": "Convert between JPG, PNG, and WebP instantly in your browser."
        },
        {
          "name": "Image Watermarker",
          "url": "/image/image-watermarker",
          "description": "Add text or logo watermarks to your images with batch processing."
        },
        {
          "name": "Meme Generator",
          "url": "/image/meme-generator",
          "description": "Create memes instantly with popular templates or your own images."
        }
      ]
    }
  }
};
